import { engagementFinanceColumns, defaultHiddenColumns as financeHidden } from "./engagement-finance"
import { engagementHoursColumns, defaultHiddenColumns as hoursHidden } from "./engagement-hours"
import { engagementTimeEntriesColumns, defaultHiddenColumns as timeEntriesHidden } from "./engagement-time-entries"
import { engagementPeopleColumns, defaultHiddenColumns as peopleHidden } from "./engagement-people"

export const columnRegistry: Record<
  string,
  {
    columns: any[]
    defaultHiddenColumns: Record<string, boolean>
    /**
     * Column holding the chain root. Reports that name one get a "Roll-up engagements" toggle, which
     * groups on it and totals each group. Omitted on People, which carries no engagement column.
     */
    rollUpColumnId?: string
  }
> = {
  "engagement-finance": { columns: engagementFinanceColumns, defaultHiddenColumns: financeHidden, rollUpColumnId: "rollUpEngagement" },
  "engagement-hours": { columns: engagementHoursColumns, defaultHiddenColumns: hoursHidden, rollUpColumnId: "rollUpEngagement" },
  "engagement-time-entries": { columns: engagementTimeEntriesColumns, defaultHiddenColumns: timeEntriesHidden, rollUpColumnId: "rollUpEngagement" },
  "engagement-people": { columns: engagementPeopleColumns, defaultHiddenColumns: peopleHidden },
}
